import { useTranslation } from "react-i18next";
import { FormInput } from "@/shared/Components";
import { FieldLayout } from "@/pages/ContactsPage/Components/FieldLayout";
import type { FC } from "react";

type Props = {
  index: number;
  onBlur?: () => void;
  onChange?: () => void;
};

export const PhoneField: FC<Props> = ({ index, onBlur, onChange }) => {
  const { t } = useTranslation();

  const handleBlur = () => {
    onBlur?.();
  };

  return (
    <FieldLayout>
      <FormInput
        name={`phones.${index}.phoneType.name`}
        placeholder={t("contactsPage.generalInfo.type")}
        onBlur={handleBlur}
        customOnChange={onChange}
      />
      <FormInput name={`phones.${index}.number`} placeholder="+44 000 000 00" onBlur={handleBlur} />
    </FieldLayout>
  );
};
